import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	DeleteSupporterVoice,
	type DeleteSupporterVoiceMutation,
	type DeleteSupporterVoiceMutationVariables,
} from './index.graphql';

export async function deleteSupporterVoice({
	commentId,
	utilityContext: {
		gql: { fetch },
	},
}: {
	commentId: string;
	utilityContext: UtilityContext;
}): Promise<DeleteSupporterVoiceMutation | null | undefined> {
	const { data: deleteResult } = await fetch<DeleteSupporterVoiceMutation, DeleteSupporterVoiceMutationVariables>({
		query: DeleteSupporterVoice,
		variables: {
			input: {
				commentId,
			},
		},
		rejectOnError: true,
		batched: false,
	});
	return deleteResult;
}
